<template>
    <fragment>
      <div class="v2_font_Montserrat">
        <b-form-row>
          <b-col cols="12">
            <b-form-group
              label="Job Title"
              label-class="v2_color_black v2_font_size_16 v2_font_weight_semibold font-weight-bold required"
              :invalid-feedback="requiredInvalidFeedback"
            >
              <b-form-input
                class="p-3 phairify-border-grey height_auto v2_font_size_16 v2_color_black"
                v-model="$v.title.$model"
                :state="validateState('title')"
              />
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="12">
            <b-form-group
              label="Description"
              label-class="v2_color_black v2_font_size_16 v2_font_weight_semibold font-weight-bold required"
              :invalid-feedback="requiredInvalidFeedback"
            >
              <b-form-textarea
                class="p-3 phairify-border-grey height_auto v2_font_size_16 v2_color_black"
                v-model="$v.description.$model"
                :state="validateState('description')"
              />
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="12">
            <b-form-group
              label="Welcome message"
              label-class="v2_color_black v2_font_size_16 v2_font_weight_semibold font-weight-bold required"
              :invalid-feedback="requiredInvalidFeedback"
            >
              <b-form-textarea
                class="p-3 phairify-border-grey height_auto v2_font_size_16 v2_color_black"
                v-model="$v.welcome_message.$model"
                :state="validateState('welcome_message')"
              />
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="12">
            <b-form-group
              label="PO or Tracking #"
              label-class="v2_color_black v2_font_size_16 v2_font_weight_semibold font-weight-bold"
            >
              <b-form-input
                class="p-3 phairify-border-grey height_auto v2_font_size_16 v2_color_black"
                v-model="$v.tracking.$model"
                :state="validateState('tracking')"
              />
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="12">
            <b-form-group
              label="Job board URL"
              label-class="v2_color_black v2_font_size_16 v2_font_weight_semibold font-weight-bold required"
              :invalid-feedback="jobBoardUrlInvalidFeedback"
            >
              <b-form-input
                class="p-3 phairify-border-grey height_auto v2_font_size_16 v2_color_black"
                v-model="$v.jobBoardUrl.$model"
                :state="validateState('jobBoardUrl')"
              />
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="12">
            <b-form-group
              label="Company"
              label-class="v2_color_black v2_font_size_16 v2_font_weight_semibold font-weight-bold required"
              :invalid-feedback="requiredInvalidFeedback"
            >
              <b-form-input
                class="p-3 phairify-border-grey height_auto v2_font_size_16 v2_color_black"
                v-model="$v.company.$model"
                :state="validateState('company')"
              />
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="12">
            <b-form-group
              label="Job Location Zip Code"
              label-class="v2_color_black v2_font_size_16 v2_font_weight_semibold font-weight-bold required"
              :invalid-feedback="zipInvalidFeedback"
            >
              <b-form-input
                class="p-3 phairify-border-grey height_auto v2_font_size_16 v2_color_black"
                v-model="$v.zipCode.$model"
                :state="validateState('zipCode')"
              />
            </b-form-group>
          </b-col>
         
        </b-form-row>
      </div>
    </fragment>
  </template>
  
  <script>
  import { validationMixin } from 'vuelidate';
  import {
    maxLength,
    minLength,
    numeric,
    required,
    url,
  } from 'vuelidate/lib/validators';
  import validateStateMixin from '@/mixins/validateStateMixin';
  import SubFormValidationMethodsMixin from '@/mixins/SubFormValidationMethodsMixin';
  
  export default {
    name: 'RecruiterIcoDetailJobInformation',
    mixins: [validationMixin, validateStateMixin, SubFormValidationMethodsMixin],
    props: {
      jobOffer: Object,
      actionName: String,
    },
    data: function () {
      return {
        title: this.jobOffer ? this.jobOffer.title : null,
        description: this.jobOffer ? this.jobOffer.description : null,
        tracking: this.jobOffer ? this.jobOffer.tracking_num : null,
        jobBoardUrl: this.jobOffer ? this.jobOffer.external_url : null,
        company: this.jobOffer ? this.jobOffer.company_name : null,
        zipCode: this.jobOffer ? this.jobOffer.location_zip_code : null,
        welcome_message: this.jobOffer ? this.jobOffer.welcome_message : null,
      };
    },
    validations: {
      title: {
        required,
      },
      description: {
        required,
      },
      welcome_message: {
        required,
      },
      tracking: {},
      jobBoardUrl: {
        required,
        url,
      },
      company: {
        required,
      },
      zipCode: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(5),
        numeric,
      },
    },
    beforeMount: function () {
      this.$root.$on('check-job-information-filled', () => {
        this.emitJobInfoFilled();
      });
    },
    computed: {
      requiredInvalidFeedback: function () {
        return 'This field is required';
      },
      zipInvalidFeedback: function () {
        if (!this.$v.zipCode.numeric) {
          return 'Must contain only numbers';
        }
        if (!this.$v.zipCode.minLength || !this.$v.zipCode.maxLength) {
          return `Zip code should be ${this.$v.zipCode.$params.minLength.min} characters long`;
        }
        return 'This field is required';
      },
      jobBoardUrlInvalidFeedback: function () {
        if (!this.$v.jobBoardUrl.url) {
          return 'Job board URL should be a valid url';
        }
        return 'This field is required';
      },
    },
    methods: {
      getData: function () {
        this.$v.$touch();
        if (this.$v.$anyError) {
          return;
        }
        return {
          title: this.title,
          description: this.description,
          tracking: this.tracking,
          jobBoardUrl: this.jobBoardUrl,
          company: this.company,
          zipCode: this.zipCode,
          welcome_message: this.welcome_message,
        };
      },
      emitJobInfoFilled: function () {
        this.$v.$touch();
        this.$root.$emit('job-information-filled', !this.$v.$anyError);
      },
      fillJobInformationData: function (data) {
        this.title = data.job_title;
        this.description = data.description;
        this.welcome_message = data.welcome_message;
        this.tracking = data.tracking_num;
        this.jobBoardUrl = data.external_url;
        this.company = data.company_name;
        this.zipCode = data.location_zip_code;
  
        data.title &&
          this.$toasted.success(
            `Job Information fields are filled with data from the ${data.title} set`,
            { duration: 3000 }
          );
      },
      onSaveDetails: function () {
        const data = this.getData();
        this.$store.state.job_information = data;
      },
    },
  };
  </script>
  
  <style lang="scss">
  .required:after {
    content: '*';
    color: red;
    display: inline-block;
    margin-left: 4px;
    font-size: 26px;
    line-height: 20px;
  }
  </style>
  